// @ts-ignore
import userService from '@/api/userService';
import { defineStore } from 'pinia';
import { AxiosError } from 'axios';
import Keycloak from 'keycloak-js';

export const useUserStore = defineStore('user', {
	state: () => ({
		keycloakInstance: undefined as Keycloak | undefined,
		userName: 'MMS USER' as String,
		isAuthenticatedUser: false,
	}),
	getters: {
		userName: (state) => state.keycloakInstance?.tokenParsed?.name ?? state.keycloakInstance?.tokenParsed?.preferred_username,
	},
	actions: {
		async logout(isPermissionError?: boolean) {
			try {
				if (isPermissionError) {
					if (this.router.currentRoute.value.name !== 'auth-error') {
						await this.router.replace({ name: 'auth-error' });
					}
				} else {
					localStorage.removeItem('keycloak-access-token');
					this.keycloakInstance
						?.logout({
							redirectUri: process.env.VUE_APP_KEYCLOAK_REDIRECT_URI,
						})
						.catch((error) => {
							console.error(error);
							window.location.reload();
						});
				}
			} catch (e) {
				console.error('Logout failed!');
				window.location.reload();
			}
		},

		async loginUser() {
			try {
				await userService.loginWithKeycloak();
				this.router.push({ name: 'home' });
			} catch (e: unknown) {
				if (e instanceof AxiosError && e.response?.status === 401) {
					return this.logout(true);
				}

				window.location.reload();
			}
		},
	},
});
